import { formatTitle } from '@directus/format-title';
import { useI18n } from 'vue-i18n';

export interface WorkspaceDisplayNameInput {
	displayName?: string | null;
	apiName?: string | null;
}

export function useWorkspaceDisplayNames() {
	const { t } = useI18n();

	function getWorkspaceDisplayName(workspace: WorkspaceDisplayNameInput | null | undefined): string {
		if (workspace?.displayName) return workspace.displayName;
		if (workspace?.apiName) return formatTitle(workspace.apiName);
		return t('common.unknown_workspace');
	}

	return { getWorkspaceDisplayName };
}
